import {
  type GetDataIngestionSourcesRequest,
  type GetDataIngestionSourcesResponse,
} from '../../types';
import { DATA_SOURCE_TO_MODULES_IMPACTED_MAP } from '../utilities/data-source-to-modules-impacted-map';
import { getDatasetAgeDays } from '../utilities/get-dataset-age-days';
import { getDatasetFreshnessStatus } from '../utilities/get-dataset-freshness-status';
import { getKnownSources } from '../utilities/get-known-sources';
import { getOverallDatasetsFreshnessStatus } from '../utilities/get-overall-datasets-freshness-status';

export const getGlobalDataFreshness = (
  response: GetDataIngestionSourcesResponse,
) => {
  const knownSources = getKnownSources(response.sources);
  const hasSources = knownSources.length > 0;

  const uploadedDatasets = knownSources.filter(
    (source) => source.type === 'customer',
  );
  const generatedDatasets = knownSources.filter(
    (source) => source.type === 'autone',
  );

  return {
    status: hasSources ? getOverallDatasetsFreshnessStatus(knownSources) : null,
    uploadedDatasets: uploadedDatasets.map((source) => {
      const ageDays = getDatasetAgeDays(source.updated_at);
      return {
        ...source,
        ageDays,
        status: getDatasetFreshnessStatus(ageDays),
        // Hardcoding the modules impacted by each data source
        // until BE builds a data-health service (atm we're using data-ingestion api)
        impacted_modules: DATA_SOURCE_TO_MODULES_IMPACTED_MAP[source.name],
      };
    }),
    generatedDatasets: generatedDatasets.map((source) => ({
      ...source,
      impacted_modules: DATA_SOURCE_TO_MODULES_IMPACTED_MAP[source.name],
    })),
  };
};

export type GetGlobalDataFreshnessResponse = ReturnType<
  typeof getGlobalDataFreshness
>;

export type GetGlobalDataFreshnessRequest = GetDataIngestionSourcesRequest;
